export default "__VITE_ASSET__D4eEK01C__"